export const SUBMITTED_TO_CATMAN_STATUS = 'Submitted to CatMan'

export const CampaignUmbrellaChildStatusLabelEnum = {
  DRAFT_CAMPAIGN: 'Draft',
  DRAFT: SUBMITTED_TO_CATMAN_STATUS,
  PENDING_APPROVAL: SUBMITTED_TO_CATMAN_STATUS,
  PENDING_CAMPAIGN: 'Feedback Received',
  APPROVED: 'Final Approved',
  REJECTED: SUBMITTED_TO_CATMAN_STATUS,
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
} as const

export type CampaignUmbrellaChildStatusLabelType =
  (typeof CampaignUmbrellaChildStatusLabelEnum)[keyof typeof CampaignUmbrellaChildStatusLabelEnum]

export enum CampaignUmbrellaSubmissionStatusEnum {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  UPCOMING = 'UPCOMING',
}

export enum CampaignSubmissionStatusEnum {
  DUE_FOR_APPROVAL = 'DUE_FOR_APPROVAL',
  DUE = 'DUE',
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
}
